import React from 'react';
import FirstApartament from './Components/FirstApartament';
import SecondApartament from './Components/SecondApartament';
import ThirdApartament from './Components/ThirdApartament';

function Floor11() {

  return (
    <div className="relative w-[100vw] mt-40 mb-40 lg:h-auto">
      <div className="w-[100vw]  relative mt-0 mb-0 flex center">
        <img
          className='w-full'
          src="/images/click/clickable-images/Floors/Direct-floors/clean-floors/Floor11K5K6.jpg"
          alt=""
        />
        <>
          <FirstApartament />
          <SecondApartament />
          <ThirdApartament />
        </>
      </div>
    </div>
  );
}

export default Floor11;
